"use strict";

exports.__esModule = true;
exports.getAdapter = getAdapter;

var _adapterDefault = _interopRequireDefault(require("./default/adapter-default"));

var _adapterStoresProduct = _interopRequireDefault(require("./stores-product/adapter-stores-product"));

var _adapterStaticPage = _interopRequireDefault(require("./static-page/adapter-static-page"));

var _adapterForumCategory = _interopRequireDefault(require("./forum-category/adapter-forum-category"));

var _adapterForumPost = _interopRequireDefault(require("./forum-post/adapter-forum-post"));

var _ItemTypes = require("../types/ItemTypes");

var _adapters;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var adapters = (_adapters = {}, _adapters[_ItemTypes.ITEM_TYPES.UNKNOWN] = _adapterDefault["default"], _adapters[_ItemTypes.ITEM_TYPES.STORES_PRODUCT] = _adapterStoresProduct["default"], _adapters[_ItemTypes.ITEM_TYPES.STATIC_PAGE] = _adapterStaticPage["default"], _adapters[_ItemTypes.ITEM_TYPES.FORUM_CATEGORY] = _adapterForumCategory["default"], _adapters[_ItemTypes.ITEM_TYPES.FORUM_POST] = _adapterForumPost["default"], _adapters);

function getAdapter(itemType) {
  var adapter = adapters[itemType] || _adapterDefault["default"];
  return addMandatoryKeys(adapter);
}

function addMandatoryKeys(adapter) {
  var IDs = _objectSpread({
    INDEX_SITE: 'site.index',
    SITE_NAME: 'site.name'
  }, adapter.IDs);

  return _objectSpread({
    IDs: IDs
  }, adapter);
}